<template>
  <VContainer fluid class="footer pb-0">
    <VContainer class="content">
      <VRow justify="space-between" wrap>
        <VCol cols="12" md="6" class="left-side">
          <div class="d-flex justify-start align-start caption font-weight-light">
            <a :href="`https://${HOME_DOMAIN}`" class="logo">
              <img src="../assets/img/logo-min.svg" alt="Huntica" width="32" class="mr-4">
            </a>
            <div>
              <div class="slogan mb-4">
                {{ $t('onlineService') }}
                {{ $t('withHumanFace') }}
              </div>
              <div
                v-if="!$route.meta.supportBtn"
                class="subtitle-2 font-weight-normal mt-2 mb-6 d-md-none"
              >
                {{ $t('candidatesSupport') }}
                <div class="d-flex align-center mt-4">
                  <VIcon small class="mr-2" color="rgba(255,255,255,0.6)">
                    {{ mdiEmail }}
                  </VIcon>
                  <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a>
                </div>
              </div>
              <!-- eslint-disable-next-line -->
              <RouterLink :to="{ name: 'confidential' }">{{ $t('confidential') }}</RouterLink>
              <br>

              <template v-if="locale === 'ru'">
                <!-- eslint-disable-next-line -->
                <RouterLink :to="{ name: 'agree' }">{{ $t('userAgreement') }}</RouterLink>
                <br>
                <!-- eslint-disable-next-line -->
                <RouterLink :to="{ name: 'rules' }">{{ $t('serviceRules') }}</RouterLink>
                <br>
                <!-- eslint-disable-next-line -->
                <RouterLink :to="{ name: 'ru-payment-info' }">{{ $t('paymentInfo') }}</RouterLink>
                <br>
              </template>
            </div>
          </div>
        </VCol>
        <VCol cols="12" md="6" class="right-side d-none d-md-flex justify-end">
          <div v-if="!$route.meta.supportBtn" class="subtitle-2 font-weight-normal">
            {{ $t('candidatesSupport') }}
            <div class="d-flex align-center mt-4">
              <VIcon small class="mr-2" color="rgba(255,255,255,0.6)">
                {{ mdiEmail }}
              </VIcon>
              <a :href="`mailto:${SUPPORT_EMAIL}`">{{ SUPPORT_EMAIL }}</a>
            </div>
          </div>
        </VCol>
      </VRow>
    </VContainer>
  </VContainer>
</template>

<script>
import { mdiEmail, mdiPhone } from '@mdi/js';
import { format } from '../date-utils';
import useLocale from '../compositions/useLocale';
import { SUPPORT_EMAIL, HOME_DOMAIN } from '@/helpers/constants';

export default {
  name: 'TheFooter',
  data() {
    return {
      mdiEmail,
      mdiPhone,
    };
  },
  setup() {
    const { locale } = useLocale();

    return {
      locale: locale.value,
      SUPPORT_EMAIL,
      HOME_DOMAIN,
    };
  },
  computed: {
    year() {
      return format(new Date(), 'yyyy');
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: linear-gradient(90deg, #0a82d9 0%, #00cbf3 100%);
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../assets/img/footer-bg.png) no-repeat right;
    background-size: cover;
  }

  .slogan {
    max-width: 170px;
  }

  .content {
    position: relative;
  }

  .left-side {
    .caption {
      color: #ffffff;
      line-height: 16px !important;

      a {
        color: #fff;
        opacity: 0.5;

        &.logo {
          opacity: 1;
        }
      }

      .copy {
        opacity: 0.5;
      }
    }
  }

  .subtitle-2 {
    line-height: 16px !important;
    color: #fff;

    a {
      color: #fff;
      opacity: 1 !important;
    }
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .header::before {
    background-image: url(../assets/img/footer-mobile-bg.png);
  }
}
</style>

<i18n locale="en" lang="yaml">
  onlineService: The first automated interview
  withHumanFace: service with a real person
  candidatesSupport: Candidate support
  confidential: Privacy policy
  userAgreement: Terms of use
  serviceRules: Conditions of service
  paymentInfo: Payment rules
  copyright: All rights reserved
</i18n>

<i18n locale="ru" lang="yaml">
  onlineService: Сервис видеособеседований
  withHumanFace: с человеческим лицом
  candidatesSupport: Служба поддержки кандидатов
  confidential: Политика конфиденциальности
  userAgreement: Пользовательское соглашение
  serviceRules: Правила оказания услуг
  paymentInfo: Правила оплаты и безопасность платежей, конфиденциальность информации
  copyright: Все права защищены
</i18n>
